import { React, useState, useEffect } from "react";
import { Feather, Menu } from "react-feather";
import OtherService from "../../services/Other";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import FeatherIcon from "feather-icons-react";
import { get } from "jquery";

const PerformanceTrends = () => {
  const [hierName, setHiername] = useState(null);
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [businessTimeframe, setBusinessTimeframe] = useState("MTD");
  const [loading, setLoading] = useState(false);

  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  const trigger = async () => {
    const hierDesc = JSON.parse(localStorage.getItem("userData")).hierCode;
    setHiername(hierDesc);
    if (hierDesc == "Contractor") {
    }
    if (hierDesc == "TSE") {
      getProductivityData("MTD");
      // getTseEnrollmentData("MTD");
    }
  };

  useEffect(() => {
    setLoyaltyData([]);
    trigger();
  }, [brandId]);

  const getTseEnrollmentData = async (option) => {
    try {
      // setLoading(true);
      let payload = {
        business_timeframe: option,
      };
      const res = await OtherService.getTseEnrollmentData(payload);
      if (res.success === true) {
        let arr = [
          {
            icon: getIcon("Target"),
            color: getColor("Target"),
            label: "% Against Target",
            value: res.response.TSE_Enrollment_Percentage,
          },
          {
            icon: getIcon("Contractor"),
            color: getColor("Contractor"),
            label: "New Contractor Enrollment",
            value: res.response.TSE_Enrollment_Achieved,
          },
        ];
        setSaleData((saleData) => [...saleData, ...arr]);
      }
    } catch (error) {
      console.error("getTseEnrollmentData api error");
    }
  };

  const getProductivityData = async (option) => {
    try {
      setLoading(true);
      const payload = {
        business_timeframe: option,
        hierarchies: [20],
      };
      const res = await OtherService.getTseContractorProductivity(payload);
      getTseEnrollmentData(option);
      if (res.success === true) {
        const arr = [
          {
            icon: getIcon("Productivity"),
            color: getColor("Productivity"),
            label: "Productivity Per Contractor",
            value: res?.response?.avg_sales_in_mt,
          },
          {
            icon: getIcon("Volume"),
            color: getColor("Volume"),
            label: "Total Volume (MT)",
            value: Number(res?.response?.total_sales_in_mt).toFixed(1),
          },
        ];
        setSaleData(arr);
        // getTseEnrollmentData(option);
      }
    } catch (err) {
      console.error("Productivity report api error");
    } finally {
      setLoading(false);
    }
  };

  const changeBusinessTimeFrame = async (option) => {
    setBusinessTimeframe(option);
    try {
      await getProductivityData(option);
    } catch (err) {
      console.error("Error while changing business timeframe:");
    }
  };

  return (
    <>
      <BigBox
        header="Performance Trends"
        options={["MTD", "YTD"]}
        selectedOption={businessTimeframe}
        onChange={changeBusinessTimeFrame}
      >
        {loading ? (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[16px] text-slate-600 font-medium">Loading...</p>
          </div>
        ) : saleData?.length > 0 ? (
          saleData.map((item, index) => {
            const img = item?.icon;
            return (
              <Box column={2} bgColor={item?.color} key={index}>
                <div
                  className="w-full"
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div
                    className="flex justify-between items-center"
                    style={{
                      display: "flex",
                      flex: 3,
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>
                      <p className="text-3xl font-extrabold text-gray-900">
                        {item?.value}
                      </p>
                    </div>

                    <div>
                      <p
                        style={{ textAlign: "left" }}
                        className="text-base font-medium text-gray-700 mt-2"
                      >
                        {item?.label}
                      </p>
                    </div>
                  </div>

                  <div
                    className="flex justify-between items-center"
                    style={{
                      display: "flex",
                      flex: 1,
                      justifyContent: "flex-end",
                    }}
                  >
                    {String(img).includes(".png") ? (
                      <img
                        src={img}
                        alt=""
                        style={{
                          height: 28,
                          width: 28,
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <FeatherIcon icon={img} />
                    )}
                  </div>
                </div>
              </Box>
            );
          })
        ) : (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[18px] font-bold text-slate-600 text-center">
              No data found !!!
            </p>
          </div>
        )}
      </BigBox>
    </>
  );
};

export default PerformanceTrends;
